import reviewsIoPdp from './reviewsio-pdp.js';

export default reviewsIoPdp;
